import { ChangePassword as CoreChangePassword } from '@namespace/account';
import { passwordRulesList } from '../../constants/forms';

const ChangePassword = () => {
  return <CoreChangePassword rulesList={passwordRulesList} />;
};

export default ChangePassword;
